import { Col, Divider, Row } from 'antd';
import useScrollToTop from '@/hooks/useScrollTop';
import PreLodgementTable from '../components/PreLodgementTable';
import CalculatorListComponent from '@/components/Calculator/Calculator';

const TaxReturns = () => {
  useScrollToTop();

  return (
    <div style={{ width: '100%', marginTop: '20px' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <PreLodgementTable />
        </Col>
        <Col xs={24}>
          <Divider />
        </Col>
        <Col xs={24} md={24} lg={12}>
          <CalculatorListComponent title="Tax Calculators" />
        </Col>
      </Row>
      <PreLodgementTable />
    </div>
  );
};

export default TaxReturns;
